export const EMBED_SESSION_KEY = 'elora_embed';

export const detectEmbedMode = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const urlEmbed =
      new URLSearchParams(window.location.search).get('embed') === '1';
    const stored = sessionStorage.getItem(EMBED_SESSION_KEY) === '1';

    let inIframe = false;
    try {
      inIframe = window.self !== window.top;
    } catch {
      inIframe = true;
    }

    if (inIframe || urlEmbed) {
      sessionStorage.setItem(EMBED_SESSION_KEY, '1');
      return true;
    }

    return stored;
  } catch {
    return false;
  }
};

export const persistEmbedMode = (): boolean => {
  const isEmbed = detectEmbedMode();
  if (isEmbed) {
    sessionStorage.setItem(EMBED_SESSION_KEY, '1');
  }
  return isEmbed;
};

export const appendEmbedParam = (path: string): string => {
  if (!detectEmbedMode()) {
    return path;
  }

  const [base, query = ''] = path.split('?');
  const params = new URLSearchParams(query);
  params.set('embed', '1');
  const queryString = params.toString();
  return queryString ? `${base}?${queryString}` : `${base}?embed=1`;
};

export const getEmbedHomePath = (): string => appendEmbedParam('/');
